<template>
  <div>Authentification</div>
</template>

<script>
  import auth from '../services/auth'

  export default {
    name: 'AuthByToken',
    mounted: function () {
      var consumer = this.$route.params.consumer
      var token = this.$route.params.token
      localStorage.setItem('auth_token', token)
      localStorage.setItem('client_id', consumer)
      this.authenticated = true
      auth.checkAuth()
      this.$router.push({path: '/'})
    }
  }

</script>

<style scoped>

</style>
